module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Loyal to the Sky")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titlepage",
    attrs: {
      "id": "d14e36"
    }
  }, [_c('h1', {
    attrs: {
      "id": "d7e204"
    }
  }, [_vm._v("Loyal to the Sky")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e254"
    }
  }, [_vm._v("Notes from an Activist"), _c('br'), _c('br')]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "d7e304"
    }
  }, [_c('b', [_vm._v("MARISA HANDLER")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "9781576759745_0004_001",
      "src": "images/9781576759745_0004_001.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7170636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TitlePage.vue
// module id = 63
// module chunks = 0